import React, { SVGProps } from 'react';

const ApiDocsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="ApiDocsIcon">
    <path
      d="M15.666 5.5V2.167H2.333V5.5h13.333Zm0 1.667H2.333v6.666h13.333V7.167ZM1.5.5h15a.833.833 0 0 1 .833.833v13.334a.833.833 0 0 1-.833.833h-15a.833.833 0 0 1-.833-.833V1.333A.833.833 0 0 1 1.5.5ZM3.167 8h2.5v4.167h-2.5V8Zm0-5h1.666v1.667H3.166V3ZM6.5 3h1.666v1.667H6.5V3Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default ApiDocsIcon;
